import { render, staticRenderFns } from "./JobDetailsTalentFindNew.vue?vue&type=template&id=c164f3b4&scoped=true"
import script from "./JobDetailsTalentFindNew.vue?vue&type=script&lang=js"
export * from "./JobDetailsTalentFindNew.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsTalentFindNew.vue?vue&type=style&index=0&id=c164f3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c164f3b4",
  null
  
)

export default component.exports